import React from 'react'

const SidebarContext = React.createContext({
  responsiveSidebarOpened: false,
  setResponsiveSidebarOpened: () => {}
})

export default SidebarContext
